import React from 'react'
import { runIfFn } from '../assertion'
import { useCallbackRef } from './useCallbackRef'

export function useControllableProp(prop, state) {
  const isControlled = prop !== undefined
  const value = isControlled && typeof prop !== 'undefined' ? prop : state

  return [isControlled, value]
}

/**
 * React hook for using controlling component state.
 * @param props
 */
export function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange,
    shouldUpdate = (prev, next) => prev !== next
  } = props
  const onChangeProp = useCallbackRef(onChange)
  const shouldUpdateProp = useCallbackRef(shouldUpdate)

  const [valueState, setValue] = React.useState(defaultValue)

  const isControlled = valueProp !== undefined
  const value = isControlled ? valueProp : valueState

  const updateValue = React.useCallback(
    next => {
      const nextValue = runIfFn(next, value)

      if (!shouldUpdateProp(value, nextValue)) {
        return
      }

      if (!isControlled) {
        setValue(nextValue)
      }

      onChangeProp(nextValue)
    },
    [isControlled, onChangeProp, value, shouldUpdateProp]
  )

  return [value, updateValue]
}
